import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RadioLangGroup } from 'components/_common/RadioLangGroup';
import { styles } from './Settings.styles';

interface DesktopLanguageProps {
  userSettings: any;
  updatedSettings: any;
  handleChangeLang: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DesktopLanguage: React.FC<DesktopLanguageProps> = ({
  userSettings,
  updatedSettings,
  handleChangeLang,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ ...styles.section, ...styles.rightPartSection }}>
      <Box sx={styles.sectionTitleWrapper}>
        <Typography variant="h3" sx={styles.sectionTitle}>
          {t('settings.lang')}
        </Typography>
      </Box>
      <Box sx={styles.sectionList}>
        <RadioLangGroup
          onChange={handleChangeLang}
          value={
            updatedSettings && updatedSettings.hasOwnProperty('portalLanguage')
              ? updatedSettings.portalLanguage
              : userSettings.data?.portalLanguage
          }
          data={[
            {
              flagIcon: 'US',
              flagName: 'English (USA)',
              value: 'en-US',
              disabled: true,
            },
          ]}
        />
      </Box>
    </Box>
  );
};

export default DesktopLanguage;
